import type { ReactNode } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

interface SiteLayoutProps {
  children: ReactNode;
  /** add top padding for pages with a normal (non-hero) header */
  padded?: boolean;
}

export default function SiteLayout({ children, padded = true }: SiteLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className={`flex-1 w-full ${padded ? 'pt-16' : ''}`}>{children}</main>
      <Footer />
    </div>
  );
}